// libraries
import clsx from 'clsx'

// components
import Error from '/react4xp/components/Form/Error'

// utils
import { useFormField } from '/react4xp/utils/useFormField'

// css
import './index.scss'

// types
interface InputProps {
	label?: string
	helper?: string
	id?: string
	name?: string
	size?: 'x-small' | 'small' | 'medium' | 'large' | 'full'
	disabled?: boolean
	placeholder?: string
	error?: string
	invalid?: boolean
	value?: string
	required?: boolean
	type?: string
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

export default function Input({
	label,
	helper,
	id,
	name,
	size = 'full',
	disabled = false,
	placeholder,
	error: externalError,
	invalid: externalInvalid,
	value: externalValue,
	required = false,
	type = 'text',
	onChange: externalOnChange,
	onKeyDown
}: InputProps) {
	const { finalError, finalInvalid, updateFormValue, getRegisterProps } = useFormField({
		name,
		externalError,
		externalInvalid,
		required
	})

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value
		externalOnChange?.(e)
		updateFormValue(newValue)
	}

	const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && onKeyDown) {
            onKeyDown(event)
        }
    }

	return (
		<div className={clsx(
			'input-component',
			finalInvalid && 'input-component--invalid'
		)}>

			{label && (
				<label className='input-component__label body'>
					{label}
				</label>
			)}

			{helper && (
				<p className='input-component__helper body-small'>
					{helper}
				</p>
			)}

			<div className={clsx(
				'input-component__input',
				size && `input-component__input--${size}`
			)}>

				<input
					{...getRegisterProps()}
					id={id}
					name={name}
					type={type}
					placeholder={placeholder}
					disabled={disabled}
					value={externalValue}
					onChange={handleChange}
					onKeyDown={handleKeyPress}
				/>

			</div>

			{finalError && finalInvalid && (
				<Error label={finalError} />
			)}

		</div>
	)
}